module.exports = __webpack_public_path__ + "assets/img/2eab0e86d2a09cc066befddb385f7296.png";